import { Tag } from "antd";

/**
 * Paleta y helpers compartidos entre los tres paneles admin
 * (Auditorías / Producción / Superficie). Vive en un módulo aparte
 * para no duplicarse y mantener la paleta en sincronía.
 */

// Paleta alineada con `getAuditDisplayState` en la tabla de audits:
// finalized=verde, planned=azul, submitted=amarillo, canceled=rojo.
// Si cambia la paleta canónica, actualizar aquí también.
export const STATUS_COLORS: Record<string, string> = {
  planned: "#1890ff",
  performed: "#722ed1",
  submitted: "#faad14",
  finalized: "#52c41a",
  canceled: "#f5222d",
  not_planned: "#8c8c8c",
};

export const STATUS_LABELS: Record<string, string> = {
  planned: "Planificada",
  performed: "Ejecutada",
  submitted: "Pdte. revisión",
  finalized: "Finalizada",
  canceled: "Cancelada",
  not_planned: "Sin planificar",
};

// Semánticas de superficie — misma paleta que la pestaña surface
// review en la tabla de audits para que el usuario asocie colores.
export const SURFACE_COLORS = {
  licensed: "#1890ff", // azul = contractual
  audited: "#52c41a",  // verde = medido en campo
  productive: "#13c2c2", // teal = productivo (subset de audited)
  netted: "#faad14",
  notNetted: "#d9d9d9",
};

export const fmtPct = (num: number, den: number) =>
  den > 0 ? `${((num / den) * 100).toFixed(1)}%` : "—";

/** Formato kg con separadores de miles. 0 → "—" para no mostrar ceros
 *  visualmente pesados en tablas largas. */
export const fmtKg = (v: number): string => {
  if (!v || v === 0) return "—";
  return `${Math.round(v).toLocaleString("es-ES")} kg`;
};

/** Formato ha con máximo 3 decimales, separador de miles es-ES.
 *  No fuerza decimales mínimos — enteros se muestran limpios.
 *  Ejemplos: 1770 → "1.770 ha"; 1770.1234 → "1.770,123 ha". */
export const fmtHa = (v: number): string => {
  if (!v || v === 0) return "—";
  return `${v.toLocaleString("es-ES", {
    maximumFractionDigits: 3,
  })} ha`;
};

/** Tag con delta % relativo a un valor previo (ej. campaña anterior).
 *  Verde si sube, rojo si baja, gris si igual. */
export const diffBadge = (current: number, prev: number) => {
  if (prev === 0) {
    return current > 0 ? <Tag color="blue">+{current}</Tag> : null;
  }
  const delta = current - prev;
  const pct = ((delta / prev) * 100).toFixed(1);
  if (delta === 0) return <Tag>=</Tag>;
  return (
    <Tag color={delta > 0 ? "green" : "red"}>
      {delta > 0 ? "+" : ""}
      {pct}% vs {prev}
    </Tag>
  );
};
